var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColourPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0706 4.92903C18.3384 4.1968 17.1797 4.15104 16.3941 4.79174C16.3417 4.83445 16.291 4.88022 16.2422 4.92903L13.4138 7.75746L12.7067 7.05035C12.3162 6.65983 11.683 6.65983 11.2925 7.05035C10.9019 7.44088 10.9019 8.07404 11.2925 8.46457L11.9996 9.17167L4.92851 16.2427C4.14746 17.0238 4.14746 18.2901 4.92851 19.0712C5.70955 19.8522 6.97588 19.8522 7.75693 19.0712L14.828 12.0001L15.5351 12.7072C15.9256 13.0977 16.5588 13.0977 16.9493 12.7072C17.3398 12.3167 17.3398 11.6835 16.9493 11.293L16.2422 10.5859L19.0706 7.75746C19.8517 6.97641 19.8517 5.71008 19.0706 4.92903ZM14.1209 11.293L12.7067 9.87878L5.63561 16.9498C5.24509 17.3404 5.24509 17.9735 5.63561 18.3641C6.02614 18.7546 6.6593 18.7546 7.04983 18.3641L14.1209 11.293Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColourPicker);
export default __webpack_public_path__ + "static/media/colour_picker.6f08af4b.svg";
export { ForwardRef as ReactComponent };